import React from "react";
import { pricing } from "../data/landing";
export function DollarPriceNotice() {
  return <div className="cd" data-id="element-17" data-mp="3gwchpj3p4odv">
      <div className="cdh" data-id="element-18" data-mp="3gujb23t3245v">
        <i data-id="element-19" data-mp="3gxxdtd5nsfdu">⚡</i>
        <span data-id="element-20" data-mp="3gxnprv46cias">Você paga na moeda do seu país</span>
      </div>
      <div className="cdt" data-id="element-21" data-mp="326f2hsnqv90t">
        <div className="tc" data-id="element-22" data-mp="3253ybrqdzz96">
          <span className="tcv" data-id="element-23" data-mp="375hvgeqg9osf">{pricing.price}</span>
          <small data-id="element-24" data-mp="3746vkq04l16l">HOJE VOCÊ PAGA</small>
        </div>
        <div className="sep" data-id="element-25" data-mp="2t60eumnb5hu5">→</div>
        <div className="tc tcx" data-id="element-26" data-mp="2t4p1pw7z2xqd">
          <span className="tcv tco" data-id="element-27" data-mp="2x7vdtkhrnj4r">{pricing.originalPrice}</span>
          <small data-id="element-28" data-mp="2x9es55jv3k3w">PREÇO NORMAL</small>
        </div>
      </div>
      <p className="cdp" data-id="element-29" data-mp="2j8vpkdy61694">
        A coleção está cotada em <b data-id="element-30" data-mp="2ja6uwi79em2c">dólares</b> e o pagamento é convertido para a sua moeda no câmbio do dia. Se o
        dólar subir, amanhã fica mais caro. <b data-id="element-31" data-mp="hgz3iaedge03">Comprando hoje, você garante o preço de hoje.</b>
      </p>
    </div>;
}